/*
    Copyright NetFoundry Inc.

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at

    https://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
*/

import {Injector} from "@angular/core";
import {SettingsService, SETTINGS_SERVICE} from "./services/settings.service";
import {ZAC_LOGIN_SERVICE, LoginServiceClass} from "./services/login-service.class";

export function onAppInit(injector: Injector): () => Promise<any> {
    const loginService = injector.get(ZAC_LOGIN_SERVICE, LoginServiceClass);
    const settingsService = injector.get(SETTINGS_SERVICE, SettingsService);
    return () => Promise.all([settingsService.init(), loginService.init()]);
}
